import CarouselContent from "../framework/carousel/CarouselContent";
import Button from "../framework/Button";
import images from "../assets/images/index";
const { LoginScreen02, LoginScreen01 } = images;
const carousel1 = (
  <CarouselContent>
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%",
        width: "100%",
        textAlign: "left",
      }}
    >
      <div
        style={{
          height: "100%",
          display: "flex",
          verticalAlign: "middle",
          alignItems: "center",
        }}
      >
        <img
          style={{
            width: "100%",
            height: "100%",
          }}
          alt="LoginScreen01"
          src={LoginScreen01}
        />
      </div>
    </div>
  </CarouselContent>
);
const carousel2 = (
  <CarouselContent>
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%",
        width: "100%",
        textAlign: "left",
      }}
    >
      <div
        style={{
          height: "100%",
          display: "flex",
          verticalAlign: "middle",
          alignItems: "center",
        }}
      >
        <img
          style={{
            width: "100%",
            height: "100%",
          }}
          alt="LoginScreen02"
          src={LoginScreen02}
        />
      </div>
    </div>
  </CarouselContent>
);

export const slides = [carousel1, carousel2];
